import { DateTime } from 'luxon';

export const formatDate = (dateTime: string | Date) => {
    if (!dateTime) return;

    if (typeof dateTime !== 'string') {
        dateTime = dateTime.toISOString();
    }

    return DateTime.fromISO(dateTime, { zone: 'utc' }).setZone('Europe/Kyiv').toFormat('yyyy-MM-dd HH:mm:ss');
};
